import type { ApiScheduledGame } from "../../../../api/index.ts";
import { FormattedDate } from "../../../../components/index.tsx";
import { isToday } from "../../../../utils/index.ts";
import styles from "./GameTimestamp.module.css";

/**
 * If the game is today, show the time in the format "Today, 12:00 PM EST"
 * Otherwise, show the date in the format "Jan 1, 12:00 PM EST"
 */
export const GameTimestamp = ({
  game,
}: {
  game: Pick<ApiScheduledGame, "timestamp">;
}) => {
  if (isToday(game.timestamp)) {
    return (
      <span className={styles.uppercase}>
        <FormattedDate
          value={game.timestamp}
          hour="numeric"
          minute="numeric"
          timeZoneName="short"
        />
      </span>
    );
  }

  return (
    <span className={styles.uppercase}>
      <FormattedDate
        value={game.timestamp}
        month="numeric"
        day="2-digit"
        year="numeric"
      />
    </span>
  );
};
